import { Component, OnInit } from '@angular/core';
import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableExtraParams } from 'projects/common/src/app/interfaces/table/table-extra-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { CacheService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { ICheckFilter } from 'src/app/modules/core/interfaces/check-filter';
import { IFilterConfig } from 'src/app/modules/core/interfaces/filter-config';
import { IOutputFilter } from 'src/app/modules/core/interfaces/output-filter';
import { DatePresentationPipe } from 'src/app/modules/core/pipes/date-presentation.pipe';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ILayoutConfig } from 'src/app/modules/layout/interfaces/layout-config';
import { LayoutConfigService } from 'src/app/modules/layout/services/layout-config.service';
import { ReportDrillingService } from '../../services/report-drilling.service';

@Component({
  selector: 'app-report-drill-hcm',
  templateUrl: './report-drill-hcm.component.html',
  styleUrls: ['./report-drill-hcm.component.scss'],
})
export class ReportDrillHcmComponent implements OnInit {
  public message: string;
  public showFilter: ICheckFilter;
  public tableConfig: ITableConfig;
  public tableByMachineHCM: ITableConfig;
  public reportDataHCM: any;
  public hasData: boolean;
  public hideReport: boolean;
  public systemError: string;
  public params: IOutputFilter;
  public filterConfig: IFilterConfig;
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private languageService: LanguageService,
    private cacheService: CacheService,
    private reportDrillingService: ReportDrillingService,
    private tableConfigService: TableConfigService,
    private datePipe: DatePresentationPipe,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _excelExportService: ExcelExportService,
  ) {
    this.initDefaultFilterMachine();
    this.hasData = false;
    this.hideReport = true;
    this.disabledExcelBtn = false;
  }

  /**
   * On init Component
   */
  public ngOnInit(): void {
    const config: ILayoutConfig = {
      title: 'reports',
      subtitle: 'report-drilling',
      imageKey: 'report',
      imageType: 'section',
    };

    this.layoutConfigService.setConfig(config);
  }

  /**
   * Init default filter machine
   */
  public initDefaultFilterMachine(): void {
    const allMachines = this.cacheService.session('machineCollection') as IMachineContext[];
    const selected = allMachines.find((v) => v.code === 'JMB');

    this.filterConfig = {
      dates: { required: true },
      shift: { required: true },
      machineType: { required: true, uniqueSelection: selected },
      machineList: { required: true, multiselect: true },
      cleanButton: true,
    };
  }

  /**
   *  get data report drilling HCM
   */
  public getReportFilteredHCM($event: IOutputFilter): void {
    this.filterConfig.isLoading = true;

    this.params = {
      startDate: $event.startDate,
      endDate: $event.endDate,
      shiftId: $event.shiftId,
      machineTypeId: $event.machineTypeId,
      machineId: $event.machineId,
    };

    this.reportDrillingService.getDataDrillHCM(this.params).then(
      (result) => {
        this.reportDataHCM = result;

        if (
          this.reportDataHCM &&
          this.reportDataHCM.totalDepth.length &&
          this.reportDataHCM.totalByMachine.length &&
          this.reportDataHCM.totalDepth.length
        ) {
          this.message = '';
          this.setTableConfig(this.reportDataHCM.drillGrouped);
          this.setTableByMachineHCM(this.reportDataHCM.totalByMachine);
          this.hasData = true;
          this.hideReport = false;
        } else {
          this.message = this.languageService.message('m034');
          this.hasData = false;
          this.hideReport = true;
        }

        this.filterConfig.isLoading = false;

        this.systemError = '';
        this.setTableConfig(this.reportDataHCM.drillGrouped);
        this.setTableByMachineHCM(this.reportDataHCM.totalByMachine);
      },
      ({ name, message }) => {
        console.error(message);
        this.systemError = name === 'TimeoutError' ? 'm014' : 'm017';
        this.hideReport = true;
        this.hasData = false;
        this.filterConfig.isLoading = false;
      },
    );
    const filters = {
      reports: 'report-drill-hcm',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }

  /**
   * set table Config summary
   */
  public setTableConfig(tableData: any[]): void {
    const excludeColumns = ['machineId', 'shiftId'];

    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns,
      replaceColumnName: [
        { prevName: 'countDisplacementNumber', newName: 'drillings' },
        { prevName: 'depth', newName: 'mts-drill' },
        { prevName: 'displacementNumber', newName: 'stick' },
        { prevName: 'statusName', newName: 'type-activity' },
      ],
      sortables: true,
    };

    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns,
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    this.tableConfig = null;
    setTimeout(() => (this.tableConfig = { header, dataset }), 0);
  }

  /**
   * set table Machine HCM
   */
  public setTableByMachineHCM(tableData: any[]): void {
    const extraParams: ITableExtraParams = {
      minimalRows: 6,
      disableFooter: true,
    };

    const headerParams: ITableHeaderParams = {
      data: tableData,
      replaceColumnName: [
        { prevName: 'totalCountDisplacementNumber', newName: 'drillings' },
        { prevName: 'totalDepth', newName: 'mts-drill' },
      ],
    };

    const datasetParams: ITableDataParams = {
      tableData,
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    this.tableByMachineHCM = null;
    setTimeout(() => (this.tableByMachineHCM = { header, dataset, extraParams }), 0);
  }

  /**
   * Download excel file for report fronts
   */
  public downloadExcel(): void {
    const params = {
      startDate: this.params.startDate,
      endDate: this.params.endDate,
      shiftId: this.params.shiftId,
    };

    const selectRangeDate = {
      startDate: this.datePipe.transform(this.params.startDate),
      endDate: this.datePipe.transform(this.params.endDate),
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.reportDrillingService.getDrilliHCMReportExcel(params).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'drilling-report', selectRangeDate, null, false);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
